import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import {makeStyles} from '@material-ui/core/styles';
import {setErrorInformation} from "../../redux/application";
import {activate} from '../../redux/user';


const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
  })
);


export default function Activate(props) {
  const dispatch = useDispatch();

  useEffect( () => {
    const activationCode = window.location?.hash?.substring(1);
    if (!activationCode){
      dispatch(setErrorInformation('Пустий код активації'));
    }
    else {
      dispatch(activate(activationCode));
    }
  }, []);


  const classes = useStyles();


  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Typography variant="h4" noWrap>
          Активація, зачекайте будь ласка....
        </Typography>
      </div>
    </Container>
  );
}

